import { render, staticRenderFns } from "./ownGraphChart.vue?vue&type=template&id=196487cd&scoped=true"
import script from "./ownGraphChart.vue?vue&type=script&lang=js"
export * from "./ownGraphChart.vue?vue&type=script&lang=js"
import style0 from "./ownGraphChart.vue?vue&type=style&index=0&id=196487cd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196487cd",
  null
  
)

export default component.exports